export default {
  methods: {
    formatCurrency(value) {
      return Number(value).toLocaleString("en-GB", {
        currency: "GBP",
        style: "currency",
        minimumFractionDigits: value % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2,
      });
    },
  },
};
